/*!
 * Image Tag
 */

export default class ImageTag extends HTMLElement {
  x;
  y;

  constructor() {
    super();

    window.addEventListener('resize', this.repaint());
  }

  static get observedAttributes() {
    return ['name', 'x', 'y'];
  }

  connectedCallback() {
    this.repaint();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.x = this.getAttribute('x');
    this.y = this.getAttribute('y');
    this.textContent = this.getAttribute('name');
  }

  repaint() {
    if (this.parentNode === null) return;

    let w = this.offsetWidth;
    let h = this.offsetHeight;
    let pw = this.parentNode.offsetWidth;
    let ph = this.parentNode.offsetHeight;
    this.style.left = `${this.x * pw - w / 2}px`;
    this.style.top = `${this.y * ph - h / 2}px`;
  }
}
